import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import RemoteIcon from '@/components/RemoteIcon/RemoteIcon';
import {Text} from '@/components/Typography';
import useExternalLinks from '@/hooks/useExternalLinks';
import type {BreakdownRow} from '@/services/experienceScore/mappings/metricMapping';

interface BreakdownListRowProps {
    row: BreakdownRow;
    learnMoreLabel?: string;
    onRowButtonClick: (row: BreakdownRow) => void;
}

const BreakdownListRow = ({row, learnMoreLabel, onRowButtonClick}: BreakdownListRowProps) => {
    const hasExternalLink = Boolean(row.learnMoreExternalLink);
    const openExternalLink = useExternalLinks({externalLink: row.learnMoreExternalLink ?? null});

    return (
        <li className='flex items-center justify-between gap-2 py-4 text-left'>
            <div className='flex items-center gap-2'>
                {row.icon && <RemoteIcon icon={row.icon} className='size-8 shrink-0' />}
                <div className='flex flex-col gap-1'>
                    <div className='flex flex-col'>
                        <Text variant='listTitle'>{row.label}</Text>
                        <Text variant='listText' className='text-orion-divider dark:text-romance'>
                            {row.description}
                        </Text>
                    </div>
                    {row.button?.text && (
                        <button
                            type='button'
                            onClick={() => onRowButtonClick(row)}
                            className='mt-1 flex cursor-pointer items-center gap-1 self-start'
                        >
                            <Text variant='inlineButton'>{row.button.text}</Text>
                            <ChevronDownIcon className='size-4 -rotate-90' />
                        </button>
                    )}
                    {hasExternalLink && learnMoreLabel && (
                        <button
                            type='button'
                            onClick={openExternalLink ?? undefined}
                            className='mt-1 flex cursor-pointer items-center gap-2 self-start'
                        >
                            <Text variant='inlineButton'>{learnMoreLabel}</Text>
                            <ChevronDownIcon className='size-4 -rotate-90' />
                        </button>
                    )}
                </div>
            </div>
            {row.share && (
                <span className='shrink-0 rounded-full bg-secondary px-4 py-1 dark:bg-dark-gray'>
                    <Text as='span' variant='metricValue'>
                        {row.share}
                    </Text>
                </span>
            )}
        </li>
    );
};

export default BreakdownListRow;
